<template>
  <HqDrawer
    title="恒企分期"
    :visible.sync="drawer"
    :showHeader="false"
    size="86%"
    ref="drawer"
    :modal="!!!code"
    :wrapperClosable="!!!code"
    :style="{'pointer-events': code?'none':'auto'}"
  >

    <div class="fenqi">
      <h2 class="fq-title">恒企分期</h2>
      <div class="fq-content">

        <h3 class="fq-title">订单信息</h3>
        <div class="fq-info fq-border">
          <p>{{collectionForm.goodsName? collectionForm.goodsName : ''}}</p>
          <p>{{collectionForm.orderNo? collectionForm.orderNo : ''}}</p>
          <p>{{collectionForm.stuName + '（' + collectionForm.stuMoblie + '）'}}</p>
          <div class="fq-price">
            <span class="litter-title">价格</span>
            <span style="color: red;font-size: 24px">¥ {{collectionForm.amountReceivable || "0.00"}} </span>
          </div>
        </div>

        <h3 class="fq-title" style="margin-top: 16px;">分期支付</h3>
        <div class="fq-select-container">
          <div v-for="(item, index) in fenqiPlanArr" :key="index" class="fq-select fq-border" :style="{display: item.installmentPlan.installmentConfig.status == 0 ?'block' : 'none'}">
            <div class="fq-select-title">
              <h3>{{item.installmentPlan.installmentConfig.periods}}期分期</h3>
              <span class="tag tag1" :class="{ tag2: item.installmentPlan.installmentConfig.feeList[0].feeRate > 0.05 }" v-if="item.installmentPlan.installmentConfig.feeList && item.installmentPlan.installmentConfig.feeList.length>0">{{ item.installmentPlan.installmentConfig.feeList[0].feeRate > 0.05 ? '灵活': '低息'}}</span>
              <span class="tag tag0" v-else>免息</span>
            </div>
            <div class="fq-select-money">
              <span>约¥ {{item.installmentConfig.firstPayment.toFixed(2)}}</span>/期
            </div>
            <div class="fq-select-info">
              <p>首期支付 ¥{{item.installmentConfig.firstPayment.toFixed(2)}}，剩余{{item.installmentPlan.periods - 1}}期</p>
              <p>每期间隔{{item.installmentPlan.periodValue}}天<span v-if="item.installmentPlan.installmentConfig.feeList && item.installmentPlan.installmentConfig.feeList.length>0">，总手续费{{ item.installmentPlan.installmentConfig.feeList[0].feeRate | toPercentage}}% </span></p>
            </div>
            <div class="fq-select-radio">
              <el-radio v-model="radio" @change="changeRadio(index)" :label="index+1" :disabled="isConfirmPlan">选择此方案</el-radio>
            </div>
          </div>
        </div>

        <h3 class="fq-title" style="margin-top: 16px;">分期还款计划</h3>
        <div class="fq-plan-list">
          <el-table
            :data="selectPlan.installmentDetailList"
            style="width: 100%">
            <el-table-column
              prop="period"
              label="期数"
              min-width="80">
              <template slot-scope="scope">
                第{{scope.row.period}}期
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="还款金额"
              min-width="100">
              <template slot-scope="scope">
                {{ scope.row.dueAmount && scope.row.dueAmount.toFixed(2) || '0.00' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="principalAmount"
              label="包含本金"
              min-width="100">
              <template slot-scope="scope">
                {{ scope.row.principalAmount && scope.row.principalAmount.toFixed(2) || '0.00' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="dueAmount"
              label="包含手续费"
              min-width="100">
              <template slot-scope="scope">
                {{ scope.row.dueAmount && scope.row.principalAmount &&  (scope.row.dueAmount - scope.row.principalAmount).toFixed(2) || '0.00' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="dueDate"
              label="还款日期"
              min-width="160">
              <template v-slot:default="{ row }">
                <span v-if="row.dueDate!= '- -'">{{ row.dueDate | formatDate('YYYY-MM-DD HH:mm:ss') }}</span>
                <span v-else>- -</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="payStatusName"
              label="状态"
              min-width="100">
              <template slot-scope="scope">
                <el-tag type="warning" v-if="scope.row.payStatus==1">{{scope.row.payStatusName}}</el-tag>
                <el-tag type="success" v-else-if="scope.row.payStatus==3">{{scope.row.payStatusName}}</el-tag>
                <el-tag type="danger" v-else>{{scope.row.payStatusName}}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="fq-total" v-if="selectPlan.installmentPlan">
          <p class="total-1"><span>课程总金额：</span><span class="money">¥ {{selectPlan.installmentPlan.totalPrincipalAmount.toFixed(2)}}</span></p>
          <p class="total-2"><span>分期总手续费：</span><span class="money">¥ {{selectPlan.installmentPlan.totalFeeAmount ? selectPlan.installmentPlan.totalFeeAmount.toFixed(2) : 0.00}}</span></p>
          <p class="total-3"><span class="fq-title">还款总额：</span><span class="money">¥ {{selectPlan.installmentPlan.totalDueAmount.toFixed(2)}}</span></p>
        </div>
        
      </div>
      <div class="loading" :class="{loadingShow:qrcodeLoading}" v-loading="qrcodeLoading" element-loading-background="rgba(127, 127, 127, 0.3)"></div>
    </div>

    <div slot="footer">
      <el-button size="small" @click="$refs.drawer.close()">返回</el-button>
      <el-button size="small" type="primary" @click="openModal(paytxt)" v-if="selectPlan.installmentPlan">
        {{paytxt.txt}}
      </el-button>
    </div>

    <!-- 二维码 弹窗-->
    <el-dialog title="确认支付款项" :visible.sync="showQRModal" width="620px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div style="padding-right: 20px;">
        <div class="select_pay">
          <div class='qk_box'>
            <div class="pay_weys">选择支付方式</div>
            <ul class="zhifubao_wechat">
              <li :class="{active:payIndex==1}" @click="changPaystatus(1)">
                <img src="@/assets/image/zhifubao-logo.png" alt />
              </li>
              <li :class="{active:payIndex==2}" @click="changPaystatus(2)">
                <img src="@/assets/image/wxzhifu-logo.png" alt />
              </li>
            </ul>
            <div class="pay_for_pay" v-if="payIndex === 1  || payIndex === 2">
              <div class="pay_for_content">
                <div class="payFor_Box">
                  <img class="alipay" v-if="payIndex === 1 && !qrcodeLoading" src="@/assets/image/alipay_scan.png" alt />
                  <img class="alipay" v-if="payIndex === 2 && !qrcodeLoading" src="@/assets/image/wechat_pay_scan.png" alt />
                  <div class="code_two">
                    <div id="qrcode_box" style="display: flex;justify-content: center;padding-right: 20px; height:210px;" v-loading="qrcodeLoading"></div>
                  </div>
                  <!-- <div class="desc">
                    支付码自动
                    <span @click="refreshQrcode(true)">刷新</span>
                  </div> -->
                </div>
                <div class="pay_scan_logo" v-show="!qrcodeLoading">
                  <i class="iconfont iconsaoyisao"></i>
                  <div>
                    <ul>
                      <li v-if="payIndex===2">请使用微信扫描</li>
                      <li v-else>请使用支付宝扫描</li>
                      <li>二维码完成支付</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="important-tips">重要提醒：若未按约定时间还款，逾期记录将可能影响您的个人征信，请务必按时履约</div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showQRModal = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 协议 弹窗-->
    <el-dialog title="在线恒企分期签约" center :visible.sync="rsModalVisible" width="620px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" class="fenqi-xieyi">
      <div class="modal-wrapper">
        <div class="modal-wrapper-post" style="padding:0">
          <div class="post-content" ref="postImg">
            <div class="post-content-body">
              <div  class="goods-img" :style="{backgroundImage: `url(${Formmoney.classImg})`}" alt="" ></div>
              <div>
                  <p class="goods-name">{{Formmoney.commodityName }}</p>
                  <p v-if="Formmoney.businessId == 1" class="rules">{{Formmoney.goodsDetail || ' '}}</p>
                  <h3 v-if="Formmoney.businessId === 0 || Formmoney.businessId === '0'" class="rules" style="margin-left:5px">
                    <span>{{Formmoney.major}}, {{Formmoney.academicLevel}}</span>
                  </h3>
                  <p class="stu-name">
                    <span>报名学员</span>
                    <span>{{Formmoney.stuName}}</span>
                  </p>
              </div>
              <div class="post-content-bottom">
                <div id="qrcode_heyue" ref="qrcode_heyue" class="qr-code"></div>
                <div class="tips">
                  <img  style="margin-bottom:6px" src="@/assets/image/fingerprint.png" alt="">
                  <p>长按识别二维码</p>
                  <p>立即签约分期协议</p>
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCloseXieyi">关闭</el-button>
        <el-button size="small" type="primary" @click="getPostImg">下载海报</el-button>
      </span>
    </el-dialog>

  </HqDrawer>
</template>

<script>

import QRCode from "qrcodejs2";
import html2canvas from 'html2canvas';
import { formatTimesFileName } from '@/utils/timeDate';

export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      drawer: false,
      code: 'fenqi',//弹窗类型
      collectionForm: {},//订单收款信息
      fenqiPlanArr: [],// 分期方案列表
      selectPlan: {},// 选中的分期方案
      radio: 1,

      showQRModal: false,
      payIndex: 0, //切换支付按钮的状态
      // showQrcode: true,//二维码显示
      qrcodeLoading: false,
      payForSouce: {
        "1": [],
        "2": [],
        "3": []
      },
      payLock: {
        "1": null,
        "2": null,
      },
      isConfirmPlan: false,// 首次选择方案后，是否确认已经锁定方案
      // ---协议相关
      rsModalVisible: false,
      xieyiCode: '',
      createCode: {
        // id: "",
        payPrice: "",  //支付价格
        transactionTime: "", //成交日期
        schoolName: "",   //财务组织
        actionUser: "",  //制单人
        payMode: "1",   //收款方式
        payChannel: "alipay", //支付方式
        goodsDetail: '',
        showGoodsDetail: '',
        //学习账号
        stuMoblie: '',
        //商品名称
        goodsName: '',
        waitPay: '',
        //学员姓名
        stuName: '',
        stages: ""
      },
      Formmoney: {},
      orderDetails: {},
      qr: null,
      // ---协议相关

    };
  },
  computed: {
    paytxt() {
      const list = this.selectPlan.installmentDetailList;
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.payStatus !== 3) {
          if(item.period == 1){
            return {
              dueAmount: item.dueAmount,
              period: item.period,
              txt: `确认分期并支付首期 ¥ ${item.dueAmount.toFixed(2)}`,
              payAll: false,
            };
          }else{
            return {
              dueAmount: item.dueAmount,
              period: item.period,
              txt: `确认支付第${item.period}期 ¥ ${item.dueAmount.toFixed(2)}`,
              payAll: false,
            };
          }
          break; // 中断退出循环
        }else if(item.payStatus == 3){
          if(item.period == list.length){
            return {
              dueAmount: item.dueAmount,
              period: item.period,
              txt: `已支付完成，关闭`,
              payAll: true,
            };
            break; // 中断退出循环
          }
        }
      }
    }
  },
  filters: {
    toPercentage(value) {
      const rate = value * 100;
      return parseFloat(rate.toFixed(2)).toString();
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.orderId) {
      ////下面代码除了orderId，其他参数已经改成了通过 getFindOrderDetailsByOrderId、getPayDetail从后台获取
      this.createCode.orderId = this.$route.query.orderId
    }
    this.getFindOrderDetailsByOrderId();
  },
  methods: {
    init(row) {
      this.$refs.drawer.init()
      this.drawer = true
      this.collectionForm = row
      console.log(this.row)
      this.getHqInstallmentPayInfo()
    },
    // 取消
    cancel() {
      this.$refs.drawer.close()
    },
    // 获取分期支付详情
    async getHqInstallmentPayInfo() {
      const params = {
        orderId: this.collectionForm.orderId
      }
      const {code, data, msg} = await this.$fetch("getHqInstallmentPayInfo", params)
      .catch(res =>{
        this.$message.error(res.msg);
      })
      if(code == 200){
        this.fenqiPlanArr = data
        this.selectPlan = data[0]
      }else{
        this.$message.error(msg);
      }
    },
    // 选择分期方案
    changeRadio(index){
      if(this.isConfirmPlan){
        this.$message.error('您选择的分期方案已最终确认，暂不支持切换。');
        return
      }
      console.log(index)
      this.selectPlan = this.fenqiPlanArr[index]
    },
    // 打开弹窗-根据接口判断是打开协议弹窗/ 支付弹窗
    openModal(paytxt){
      if(this.fenqiPlanArr.length>1){ // 多个分期选项
        this.$hqMessageBox({
          title: '提示',
          message: `确定选择${this.selectPlan.installmentConfig.periods}期分期方案,
          确认后系统将锁定该方案，且不支持切换。`
        }).then( ()=>{
          this.getPayLink(paytxt)// status： null 和 1 （1代表点击确认按钮调用方法） 
        }).catch( ()=>{
          
        })
      }else{// 只有一个分期方案选择
        this.getPayLink(paytxt)// status： null 和 1 （1代表点击确认按钮调用方法） 
      }
    },
    // 关闭支付弹窗
    closeRechargeAmount(){
      this.payIndex = 0
      this.showQRModal = false
    },
    // 清除fetch 定时器 等
    cancelFetchs() {
      const payForSouce = this.payForSouce
      const payLock = this.payLock
      payForSouce[1][0] && payForSouce[1][0].cancel && payForSouce[1][0].cancel()
      payForSouce[1][1] && payForSouce[1][1].cancel && payForSouce[1][1].cancel()
      payForSouce[2][0] && payForSouce[2][0].cancel && payForSouce[2][0].cancel()
      payForSouce[2][1] && payForSouce[2][1].cancel && payForSouce[2][1].cancel()
      payForSouce[1][2] && payForSouce[1][2].cancel && payForSouce[1][2].cancel()
      payForSouce[2][2] && payForSouce[2][2].cancel && payForSouce[2][2].cancel()
      payForSouce[3][2] && payForSouce[3][2].cancel && payForSouce[3][2].cancel()
      clearTimeout(payLock[1])
      clearTimeout(payLock[2])
      clearInterval(this.timer)
    },
    // 改变支付方式
    async changPaystatus(index) {
      if (this.payIndex == index)
        return
      this.payIndex = index
      this.cancelFetchs()
      this.getPayLink()
    },
    // 获取支付地址 【支付宝，微信】
    async getPayLink(firstBtnData) {// status： null 和 传paytxt （paytxt代表点击确认按钮调用方法） 
      if(this.paytxt.payAll){// 如果全部支付完成，则不需要打开弹窗
        this.$refs.drawer.close()
        return
      }
      this.qrcodeLoading = true;
      const params = {
        bizCode: this.payIndex == 2 ? 'WECHAT' : 'ALIPAY',
        installmentConfigId: this.selectPlan.installmentPlan.installmentConfig.id,
        orderId: this.collectionForm.orderId,
      }
      const { code, msg, data } = await this.$fetch("getHqInstallmentPayCode", params)
      .catch(res =>{
        this.$message.error(res.msg);
        this.qrcodeLoading = false
      })
      if(code === 200 && data && data.contractResult){ // 打开签订协议弹窗
        this.isConfirmPlan = true
        if(firstBtnData){
          this.$message.warning('请学员先签署分期协议');
        }
        this.qrcodeLoading = false
        this.xieyiCode = data.contractResult.contractRecordId
        this.goOrderManagement()// xieyiCode
        return
      }else if(code === 200 && data && data.paymentInfo){ // 生成支付二维码
        if(firstBtnData){
          this.showQRModal = true
          this.changPaystatus(1)//默认选择第一种支付方式
        }
        this.$nextTick(()=>{
          this.setQRcode(data.paymentInfo.result)
          this.qrcodeLoading = false
        })
      }else {
        this.$message.error(msg);
        this.qrcodeLoading = false
      }
    },
    //设置支付二维码地址
    setQRcode(url) {
      document.getElementById("qrcode_box").innerHTML = '';
      new QRCode("qrcode_box", {
          width: 178,
          height: 178,
          text: url, // 二维码地址
          colorDark: "#000",
          timer: null,
          colorLight: "#fff"
      });
      document.getElementById("qrcode_box").title = '';
    },

    // --协议
    // 签约
    goOrderManagement() {
      //携带姓名，账号
      this.Formmoney.stuName   =  this.createCode.stuName;
      this.Formmoney.stuMobile =  this.createCode.stuMoblie;
      this.Formmoney.classImg  = this.createCode.classImg;
      this.Formmoney.commodityName =  this.createCode.goodsName; 
      this.Formmoney.goodsDetail =  this.createCode.goodsDetail;
      this.Formmoney.classAndName = this.createCode.classAndName
      this.Formmoney.orderId   =  this.$route.query.orderId;
      this.Formmoney.userId    =  this.$route.query.userId || this.createCode.userId;
      this.Formmoney.businessId = this.createCode.businessId;
      this.Formmoney.academicLevel = this.createCode.academicLevel;
      this.Formmoney.major = this.createCode.major;
      //等下一个runloop再执行。
      this.rsModalVisible = true;
      this.$nextTick(()=>{
        this.crateQrcode()
      })
      
    },
    async getFindOrderDetailsByOrderId(){
        let params = {
          orderId: this.$route.query.orderId,
        }
        let { data } = await this.$fetch('thrid_getOrderDetailInfo', params)
        data = data || {}
        this.usersDetails = data.usersDetails || {};
        this.orderDetails = data.orderDetails || {};
        //获取用户的id
        this.createCode.userId = this.usersDetails.userId;
        this.createCode.stuName = this.usersDetails.name;
        this.createCode.stuMoblie = this.usersDetails.mobile;
        //判断是学历还是财经
        this.createCode.businessId = this.orderDetails.businessId;
        this.getPayDetail();
    },
    async getPayDetail(){
      /***
       * orderId，
       * userId
       */
      let params = {
          tradeOrderId: this.$route.query.orderId,
          token: '',
          userId:this.Formmoney.userId || this.createCode.userId,
          schoolId: '4',
        }

        const { data } = await this.$fetch('thrid_queryOrderDetail', params)
        let temp = data && data[0] || {};
        //获取商品名称
        this.createCode.classImg = temp.originPath || temp.thumbPath;
        this.createCode.goodsName = temp.name; 
        this.createCode.goodsDetail = temp.specificationNameAll || temp.specificationNameOne || "";
        this.createCode.orderNo     = temp.orderNo;
        this.createCode.waitPay = temp.waitPayMoney; 
        if( this.createCode.goodsDetail ){
          this.createCode.showGoodsDetail =   `(${this.createCode.goodsDetail})`
          }else {
          this.createCode.showGoodsDetail =   ''
        }

       let enrollInfo = temp.enrollInfo || {};
       this.createCode.businessId = temp.businessId;
       this.createCode.academicLevel = enrollInfo.academicLevel;
       this.createCode.major  = enrollInfo.major;
    },

    // 协议海报弹窗
    // 生成二维码
    crateQrcode() {      
      let params = {
        orderId: this.Formmoney.orderId,
        userId: this.Formmoney.userId && this.Formmoney.userId.trim()
      }
      console.log(this.Formmoney.orderId, params.userId )
      let qrcodeUrl = `${process.env.VUE_APP_QRCODE}/hqfenqi?orderId=${params.orderId}&userId=${params.userId}&contractRecordId=${this.xieyiCode.toString()}`
      if( this.qr && typeof this.qr.clear == 'function' ){
        this.qr.clear();
      }
      console.log('生成签约协议二维码')
      this.qr = new QRCode("qrcode_heyue", {
        width:  98,
        height: 98, // 高度
        text: qrcodeUrl, // 二维码内容
        correctLevel: QRCode.CorrectLevel.L
      })
      this.$refs.qrcode_heyue.title = ''//去掉QRCode库设置的title属性

      this.Formmoney.classImg =  this.Formmoney.classImg || ''
      this.Formmoney.classImg =  "/mz_proxy?url="+encodeURI(`${this.Formmoney.classImg}?x-oss-process=image/resize,m_lfit,h_138,w_227`);
    },
    // 关闭协议弹窗
    onCloseXieyi() {
      this.$refs.qrcode_heyue.innerHTML = ""
      this.rsModalVisible = false
      // this.crateQrcode()
    },
    // 生成海报并且下载
    getPostImg() {
      html2canvas(this.$refs.postImg, {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        scrollY: -1,
        scrollX: -3,
        width: this.$refs.postImg.clientWidth,
        height: this.$refs.postImg.clientHeight,
        scale: window.devicePixelRatio,
      }).then(canvas => {
        // 转成图片，生成图片地址
        let imgUrl = canvas.toDataURL('image/png');
        const eleLink = document.createElement('a');
        eleLink.href = imgUrl; // 转换后的图片地址
        // 文件名 商品名-班型名-签约_学员姓名_报名时间
        // eleLink.download = '收款海报'
        eleLink.download = `${this.Formmoney.commodityName}-${this.Formmoney.goodsDetail}-签约_${this.Formmoney.stuName}_${formatTimesFileName(this.orderDetails.createTime)}`
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
      });
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__container {
  .el-drawer {
    overflow: visible!important;
    padding-left: 20px;
  }
}
.close-detail {
  padding: 10px;
  position: absolute;
  top: 16px;
  left: -46px;
}
::v-deep.customer-label {
  .clearfix {
    display: flex;
    align-items: center;
    min-height: 40px;
  }
  .el-card__header {
    line-height: 0!important;
    height: auto!important;
    position: relative;
    padding: 4px 18px!important;
  }
}
.fenqi {
  width: 100%;
  // height: 100%;
  // background: #f5f5fa;
  padding: 20px;
  padding-left: 0;

  padding-bottom: 70px;
  padding-top: 0px;
  position: relative;
  cursor: default;
  h2.fq-title{
    text-align: center;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    position: fixed;
    display: block;
    width: calc(86% - 20px);
    z-index: 100;
    background: #f5f5fa;
    right: 20px;
    top: 0;
    height: 46px;
    line-height: 46px;
  }
  .fq-content{
    width: 96%;
    margin: 0 auto;
    margin-top: 46px;
    ::v-deep .el-table td,::v-deep .el-table th{
      padding: 6px 0;
    }
    h3.fq-title{
      font-size: 14px;
      color: #333;
      font-weight: bold;
      height: 46px;
      line-height: 46px;
    }
    .fq-border{
      background: #ffffff;
      border: 1px solid #e1e4eb;
      position: relative;
      border-radius:5px;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      padding: 16px;
    }
    .fq-info{
      padding-bottom: 20px;
      width: 66%;
      position: relative;
      .fq-price{
        position: absolute;
        right: 16px;
        bottom: 16px;
        .litter-title {
          color: #999;
          font-size: 14px;
          margin-right: 10px;
          font-weight: bold;
        }
      }
    }
    .fq-select-container{
      display: flex;
      .fq-select{
        margin-left: 40px;
        flex: 1;
        min-width: 214px;
        max-width: 66%;
        .fq-select-title{
          position: relative;
          height: 30px;
          h3{
            font-size: 14px;
            color: #333;
            font-weight: bold;
          }
          .tag{
            position: absolute;
            right: 0px;
            top: 0px;
            font-size: 12px;
            display: inline-block;
            padding: 2px 6px;
            border: 2px;
          }
          .tag0{
            color: #166534;
            background-color: #DCFCE7;
          }
          .tag1{
            color: #1E40AF;
            background-color: #D8EAFE;
          }
          .tag2{
            color: #6B21A8;
            background-color: #F3E8FF;
          }
        }
        .fq-select-money{
          height: 30px;
          span{
            font-size: 14px;
            font-weight: bold;
            color: #333;
            padding-right: 5px;
          }
        }
        .fq-select-info{
          p{
            margin-bottom: 0;
          }
        }
        .fq-select-radio{
          padding-top: 10px;
        }
      }
      :first-child{
        margin-left: 0;
      }
      ::v-deep .el-radio__input {
        display: inline-block;
      }
      ::v-deep .el-radio__original {
       display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
      }
    }
    .fq-total{
      padding-top: 20px;
      .total-1{
        display: flex;
        justify-content: space-between;
        color: #333;
      }
      .total-2{
        display: flex;
        justify-content: space-between;
        color: #333;
        
        .money{
          color: #f59E0B;
        }
      }
      .total-3{
        // border-top: 1px solid #d2d8e5;
        // padding-top: 5px;
        display: flex;
        font-size: 18px;
        justify-content: space-between;
        font-weight: bold;
        color: #333;
        .money{
          color: red;
        }
      }
    }
  }
  .loading{
    background:transparent;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    &.loadingShow{
      background: rgba(127, 127, 127, 0.3);
      z-index: 10;
    }
  }

}
.demo-drawer__footer {
  position: fixed;
  width: 90%;
  right: 0;
  bottom: 0;
  text-align: center;
  line-height: 120px;
  background: #fff;
}
.rechargeAmountForm{
  ::v-deep.el-form-item.is-success .el-input__inner{
    border-color: #dcdfe6;
  }
}
.select_pay {
  // margin-top: 18px;
  background: #ffffff;
  padding: 5px 30px 0px 30px;
  .qk_box {
    .pay_weys {
      margin-bottom: 12px;
      font-size: 14px;
      font-weight: 700;
      text-align: left;
      color: #3a3c42;
    }
    .zhifubao_wechat {
      display: flex;
      li {
        text-align: center;
        width: 168px;
        height: 54px;
        line-height: 54px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border-radius: 4px;
        border: 2px solid transparent;
        box-shadow: 0 0 0 1px #e0e0e0;
        margin-right: 30px;
        cursor: pointer;
        box-sizing: border-box;
        &.active {
          border: solid 2px #337aff;;
          background-image: url("~@/assets/image/specs-selected.png");
          background-repeat: no-repeat;
          background-size: 30px;
          background-position: bottom right;
          box-shadow: none;
        }
        img {
          height: 30px;
        }
      }
    }
    .pay_for_pay {
      height: 284px;
      background: #f8f8f8;
      // margin-top: 20px;
      .pay_for_content {
        .payFor_Box {
          text-align: center;
          position: relative;
          padding-top: 20px;
          padding-bottom: 20px;
          .alipay {
            position: absolute;
            right: 3%;
            top: 12%;
            width: 26%;
          }
          .code_two {
            width: 100%;
            height: 210px;
            #qrcode {
              display: inline-block;
              width: 210px;
              height: 210px;
              border: 1px solid #ddd;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 auto;
              ::v-deep img {
                width: 178px;
                height: 178px;
                // border: 1px dashed #666;
                padding: 1px;
              }
              //
            }
          }
          .desc {
            color: #6b7580;
            line-height: 20px;
            margin-top: 10px;
            span {
              color: #337aff;
              cursor: pointer;
            }
          }
          .sao_tip {
            img {
              box-sizing: border-box;
              width: 17%;
              position: absolute;
              right: 180px;
              top: -15px;
            }
          }
        }
        .pay_scan_logo {
          // margin-top: 24px;
          display: flex;
          justify-content: center;
          i {
            font-size: 36px;
            color: #337aff;;
            padding-right: 6px;
          }
          ul {
            line-height: 16px;
            li {
              list-style: none;
              font-size: 12px;
              padding-top: 1px;
              color: #6b7580;
            }
          }
        }
      }
    }
    .pay_for_dk {
      margin-top: 18px;
      padding: 30px;
      background: #f8f8f8;
      .row1 {
        font-size: 16px;
        color: #3a3c42;
      }
      .row2 {
        display: flex;
        align-items: center;
        height: 42px;
        margin-top: 25px;
        .label {
          flex: none;
          width: 88px;
          font-size: 16px;
          color: #3a3c42;
        }
        .inputwrap {
          flex: none;
          .inputbox {
            height: 42px;

            display: flex;
            align-items: center;
            position: relative;
            .icon {
              position: absolute;
              top: 13px;
              left: 12px;
              color: #3a3c42;
              font-size: 16px;
            }
            .input {
              height: 100%;
              padding-left: 33px;
              padding-right: 27px;
              font-size: 16px;
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              &:focus {
                border-color: #337aff;
              }
              &::-webkit-input-placeholder {
                color: #a3abb8;
                text-align: right;
              }
              &::-moz-placeholder {
                color: #a3abb8;
                text-align: right;
              }
              &:-ms-input-placeholder {
                color: #a3abb8;
                text-align: right;
              }
            }
            .btn {
              cursor: no-drop;
              margin-left: 12px;
              width: 56px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              background: #a3abb8;
              border-radius: 4px;
              color: #fff;
              &.active {
                cursor: pointer;
                background-color: #337aff;
                &:hover {
                  background: #0ecea2;
                }
              }
            }
          }
          .inputres {
            .resprice {
              font-size: 20px;
              font-weight: bold;
              color: #f6612f;
            }
            .icon {
              cursor: pointer;
              margin-left: 4px;
              color: #7B8692;
              font-size: 14px;
              &.isloan {
                cursor: default;
                font-size:21px;
                color:#337aff;
                &:hover {
                  color: #337aff;
                }
              }
              &:hover {
                color: #0ecea2;
              }
            }
          }
        }
      }
      .row3 {
        font-size: 12px;
        color: #7b8692;
        margin-top: 12px;
        display: flex;
        align-items: center;
        .label {
          flex: none;
          margin-left: 88px;
        }
        .price {
          flex: none;
          margin-left: 35px;
        }
      }
      .row4 {
        display: flex;
        align-items: center;
        margin-top: 30px;
        .label {
          flex: none;
          width: 88px;
          font-size: 16px;
          color: #3a3c42;
        }
        .price {
          flex: none;
          width: 112px;
          height: 26px;
          font-size: 20px;
          font-weight: bold;
          line-height: 26px;
          color: #f6612f;
        }
      }
      .row5 {
        margin-top: 42px;
        .btn {
          cursor: pointer;
          width: 176px;
          height: 42px;
          background: #f6612f;
          border-radius: 4px;
          color: #fff;
        }
      }
    }
    .important-tips{
      padding-top: 20px;
      text-align: center;
      color: red;
      font-size: 12px;
    }
  }
}
.campusBalanceFrom{
  ::v-deep.el-form-item.is-success .el-input__inner{
    border-color: #dcdfe6;
  }
}
::v-deep.el-input__inner.height_32{
  height: 32px;
  line-height: 32px;
}
.height_32{
  ::v-deep.el-range-separator, ::v-deep.el-range__icon, ::v-deep.el-range__close-icon{
    line-height: 25px;
  }
  ::v-deep.el-range-separator{
    width: 6%;
  }
}

// 协议
.modal-wrapper {
  width: 580px;
  background: #fff;
  &-header {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 60px;
    padding-left: 30px;
    border-bottom: 1px solid #e1e4eb;
    > h2 {
      margin-right: 12px;
      font-size: 16px;
      font-weight: 700;
      color: #333;
      > span {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
    }
    > p {
      font-size: 14px;
      color: #999;
    }
    > i {
      position: absolute;
      right: 30px;
      font-size: 18px;
      color: #9bacbf;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        transform: rotate(180deg);
      }
    }
  }
  &-body {

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 50px 60px 50px 60px;
    &-left {
      font-size: 14px;
      color: #666;
      line-height: 21px;
      margin-right: 60px;
      &>h3 {
        margin-bottom: 16px;
        line-height: 30px;
        &>span:first-child {
          display: inline-block;
          text-align: right;
        }
        &>span:last-child {
          color: #333;
        }
        .money {
          color: #F54955 !important;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }



    &-right {
      width: 209px;
      height: 372px;
      opacity: 0.73;
      background: rgba(230,246,242,0.43);
      position: relative;

      #qrcode {
        background: contain;
        overflow: hidden;
      }
      .qrcode-text {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: #333;
        line-height: 16px;
        letter-spacing: 1px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 5px;
        &>img {
          width: 24px;
          height: 24px;
        }
        &>span {
          font-size: 12px;
          text-align: center;
          color: #777777;
          line-height: 16px;
          letter-spacing: 1px;
          margin-left: 9px;
        }
      }
    }

  }
  .btns {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
  }

  .post-content-header {
    padding: 12px 20px 8px;
    display: flex;
    align-items: center;
    .logo {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        object-fit: contain;
        border: 1px solid #eee;
        border-radius: 20px;
    }
    .title,.space {
      font-size: 14px;
      color: #222;
    }
    .space {
      padding: 0 8px;
    }
    .tip {
      color: #666;
      font-size: 12px;
    }  

  }

  .post-content-body {
    height: 460px;
    position: relative;
    padding: 70px 15px 36px;

    .goods-img {
        margin: 0 12px;
        width:232px;
        height:112px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100%;
        // background-size: cover;
    }
    
    .goods-name {
      padding: 5px 12px 10px;
      line-height: 18px;
      font-size: 12px;
      color: #333;
      margin-bottom: 0;
    }
    .rules {
      color: #777;
      padding: 4px 12px 10px;
      font-size: 10px;
      line-height: 16px;
      max-height: 7em;
      margin-bottom: 0;
      overflow: hidden;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 2;
      // overflow: hidden;
      // text-overflow: ellipsis;
    }
    .stu-name {
      margin: 0 12px;
      border: 1px solid #eee;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #F0FAFA;
        font-size: 12px;
        border-radius: 4px;
      span:first-child {
        color: #666;
        margin-right: 10px;
      }
      span {
        margin-left: 10px;
        color:#337AFF
      }
      
    }
  }

  .post-content-bottom {
    position: absolute;
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 18px;
    margin-bottom: 14px;
    #qrcode_heyue {
      width: 100px;
      height: 100px;
      border: 1px solid #eee;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      overflow: hidden;
    }

    .tips {
        display: flex;
        flex-direction: column;
        position: relative;
        // padding-bottom: 31px;
        margin-left: 25px;
        margin-top: 5px;
        > img {
          width: 38px;
          height: 38px;
          margin: 0 auto;
        }
        p {
          line-height: 20px;
          font-size: 12px;
          color: #666;
        }
    }
  }

  

  &-post {
    padding: 20px 0 0 0;
    .post-content {
      width: 284px;
      height: 504px;
      background: url('../../../../assets/image/online-subscript.png') no-repeat;
      background-size:cover;
      margin: 0px auto;
    }
    .refresh-qrcode {
      position: absolute;
      bottom: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      user-select: none;
      cursor: pointer;
      left: 0;
      > img {
        width: 15px;
        height: 15px;
        transition: 0.3s ease;
        &:hover {
          transform: rotate(180deg);
        }
      }
      > span {
        font-size: 12px;
        font-weight: 400;
        color: #777777;
        margin-left: 15px;
      }
    }
    .btn-wrap {
      border: 1px solid #E1E4EB;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 18px 0 20px;
      margin-top: 18px;

    }
  }
}
::v-deep .el-dialog__header{
  text-align: left;
  .el-dialog__title{
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }
}
// 禁选的样式
// 选中
::v-deep .el-radio__input.is-disabled.is-checked .el-radio__inner{
  border-color: #409EFF !important;
  background-color: #409EFF !important;
}
// .
::v-deep .el-radio__input.is-disabled.is-checked .el-radio__inner::after{
  background-color: #F5F7FA;
}
// label
::v-deep .el-radio__input.is-checked.is-disabled+.el-radio__label{
  color: #409EFF !important;
}
// 未选中
::v-deep .el-radio__input.is-disabled .el-radio__inner{
  border-color: #DCDFE6 !important;
} 
// label
::v-deep .el-radio__input.is-disabled+.el-radio__label{
  color: #606266 !important;
}
</style>